"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCasing = void 0;
const casing_1 = require("@owner/casing");
const getCasing = ({ name, pluralizedName, }) => ({
    camel: (0, casing_1.pascalToCamel)(name),
    kebab: (0, casing_1.pascalToKebab)(name),
    pascal: name,
    pluralCamel: (0, casing_1.pascalToCamel)(pluralizedName),
    pluralKebab: (0, casing_1.pascalToKebab)(pluralizedName),
    pluralPascal: pluralizedName,
});
exports.getCasing = getCasing;
//# sourceMappingURL=casing.js.map